const vessels = [
  "Gallipoli",
  "Olympos",
  "Cappadocia",
  "Aspendos",
  "Dardanelles",
  "Assos",
  "Artemis",
  "Zeugma",
  "Sumela",
  "Myra",
  "Galata",
  "Pergamon",
  "Ephesus",
  "Troy",
  "Fadiq",
  "Paqize",
  "Pol Stella",
  "Francesco Nullo",
  "Lismore",
  "Patria",
];
export default vessels;
